import HttpClient from "@/common/boot/HttpClient"
import { CTRL_MODULOS } from '@/common/boot/Constantes'

const ROTAS_POR_MODULO = {
  [CTRL_MODULOS.INSTALACAO]: 'pco-workflows/instalacao/pesquisar',
  [CTRL_MODULOS.RECUPERACAO]: 'pco-workflows/recuperacao/pesquisar',
}

const pesquisar = async ({ commit, rootGetters }, payload) => {
  commit('CARREGANDO', true)
  try {
    const moduloAtivo = rootGetters['ctrlModulos/moduloAtivo']
    const rota = ROTAS_POR_MODULO[moduloAtivo]

    if (!rota) {
      throw new Error(`Rota de pesquisa não configurada para o módulo ${moduloAtivo}`)
    }

    const response = await HttpClient.post(
      rota,
      payload
    )
    
    const paginacao = response?.data?.data

    commit('LISTAR_DADOS', paginacao?.data || [])
    commit('ATUALIZAR_PAGINACAO', paginacao || null)

    return response
  } catch (error) {
    console.error('Erro ao pesquisar workflows', error)

    commit('LISTAR_DADOS', [])
    commit('ATUALIZAR_PAGINACAO', null)

    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

export {
  pesquisar,
}
